import React, { Component } from 'react';
import Page from '../../../containers/page';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Input
} from 'reactstrap';

import Isvg from 'react-inlinesvg'

import ListBuilder from '../../../components/listBuilder';
import ErrorModal from '../../../components/errorModal';
import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../../../helpers/linkHelper';
import { API_ENDPOINT } from '../../../constants';
import viewIcon from '../../../assets/svg/eye.svg';
import refundIcon from '../../../assets/svg/refund-icon.svg';
import historyIcon from '../../../assets/svg/history-icon.svg';
import editPaymentIcon from '../../../assets/svg/edit.svg';
import cancelPaymentIcon from '../../../assets/svg/cancel-payment-icon.svg';
import addIcon from '../../../assets/svg/add-icon.svg';


import xIcon from '../../../assets/svg/x.svg';
import garbageIcon from '../../../assets/svg/garbage.svg';
import walletIcon from '../../../assets/svg/wallet.svg';
import warrning from '../../../assets/svg/warrning.svg';
import attachInvoice from '../../../assets/svg/attach.svg'
import edit from '../../../assets/svg/edit-payment-icon.svg'
import labelIcon from '../../../assets/svg/label-icon.svg'
import markPaymentIcon from '../../../assets/svg/markPaymentIcon.svg'
import adjustFreeCardIcon from '../../../assets/svg/adjust-free-card.svg'
import removeDocumentIcon from '../../../assets/svg/remove-document.svg'
import garabage from '../../../assets/svg/garbage.svg';


import Payson from '../../../components/payson';
import Swish from '../../swish';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import PdfSave from '../../../components/pdvSave';
import InfoModal from '../../../components/infoModal';
import striptags from 'striptags';
import { Player } from "@lottiefiles/react-lottie-player";
import moment from 'moment';
import downloadIcon from '../../../assets/svg/download.svg';
import deleteDocument from '../../../assets/svg/delete-document.svg'
import barsIcon from '../../../assets/svg/bars-icon.svg';
import newTab from '../../../assets/svg/newtab.svg';



import billGrey from '../../../assets/svg/bill_grey.svg';
import infoIcon from "../../../assets/svg/link-new-tab.svg";
import DatePicker from '../../../components/forms/fields/datePicker';
import Checkbox from '../../../components/forms/fields/checkbox';
import DeleteModal from '../../../components/deleteModal';
import PatientNotesPreview from '../../../components/patientNotesPreview';
import CustomFilters from './customFilters';
import CreatePayment from './createPayment';
import EditPayment from './editPayment';
import RegisterPayment from './registerPayment';
import { getExtendedPaymentManagement, getHumanReadableLabel, getHumanReadablePaymentMethod, getHumanReadableStatus, getUserPaymentPermissions } from '../helper';
import MarkAsPaid from './markAsPaid';
import MarkAsUnpaid from './markAsUnpaid';
import PreviewPayment from './previewPayment';
import ReferralStatusHistoryModal from '../../../components/referralStatusHistoryModal';
import RefundPayment from './refundPayment';
import CancelPayment from './cancelPayment';
import AttachInvoice from './attachInvoice';
import AddLabel from './addLabel';
import AdjustFreeCardCoverage from './adjustFreeCardCoverage';
import RemoveAttachedInvoice from './removeAttachedInvoice';

function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}

class PaymentExports extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            items: [],
        };
    }
    deleteExportRecord = (exportPaymentId) => {
        if (!exportPaymentId?.length === 24) return;

        fetch(API_ENDPOINT + `/api/payments/exports/${exportPaymentId}`, {
            method: 'DELETE',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            }
        }).then(res => res.json()).then((result) => {
            this.get();
        })
    }
    getPaymentExports = () => {
        const clinicId = this.props.selectedClinic ?? null;
        const groupId = this.props.selectedGroup ?? null;
        if (!clinicId || !groupId) {
            this.setState({ items: [] });
            return;
        }
        let data = {
            clinicId,
            groupId
        };

        fetch(API_ENDPOINT + `/api/payments/exports`, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(res => res.json()).then((result) => {
            let items = result?.length ? result : [];
            this.setState({ items }, () => {
                if (this.state.items?.find(item => !item?.finished)) {
                    setTimeout(() => {
                        this.get();
                    }, 1000 * 5);
                }
            });
        })
    }

    get = () => {
        this.getPaymentExports();


    }

    componentDidMount() {
        if (typeof window !== 'undefined') { window.scrollTo(0, 0); }

        this.get();


        this.interval = setInterval(() => {
            this.get();
        }, 60 * 1000);




        const userPaymentPermissions = getUserPaymentPermissions(this.props.uData, this.props.selectedGroup, this.props.selectedClinic);
        this.setState({ userPaymentPermissions });

    }



    componentWillUnmount() {
        if (this.interval) clearInterval(this.interval);

        // if (this.props.socket) {
        //     this.props.socket.removeListener('newPayment');
        // }

    }

    componentDidUpdate(prevProps) {
        if (prevProps[0].location.search != this.props[0].location.search) {
            this.setState({
                loading: true
            }, () => {
                this.get();

            })
        }



    }



    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }

        const groupData = selectedGroupIdx > -1 ? this.props.uData?.clinicGroups?.[selectedGroupIdx] : null;

        return groupData;
    }
    getCurrency = () => {
        return this.props.currency ? this.props.currency : typeof window !== 'undefined' && localStorage?.getItem("currency") ? localStorage.getItem("currency") : '';
    }

    render() {
        const currency = this.getCurrency();

        const userPaymentPermissions = this.state.userPaymentPermissions || {};

        const groupData = this.getGroupData();

        const EXTENDED_PAYMENT_MANAGEMENT = getExtendedPaymentManagement(groupData);

        const items = this.state.items || [];
        const selectedPaymentExport = this.props.selectedPaymentExport;
        return (
            <div>
                <div className="panel-header" style={{ marginBottom: 0 }}>
                    <h5 className="component-header">{'Payments'.translate(this.props.lang)} </h5>
                </div>

                <div className="payment-exports-wrap">
                    {
                        items?.map((item, idx) => {
                            const url = item?.folderPath && item?.fileName ? `${API_ENDPOINT}${item?.folderPath}${item?.fileName}.xlsx` : null;
                            const isItemSelected = selectedPaymentExport === item?._id ? true : false;
                            return (
                                <div className={isItemSelected ? 'payment-exports-item-wrap selected-payment-exports-item-wrap' : 'payment-exports-item-wrap'} key={idx}>
                                    <div className='export-data-wrap'>
                                        <div className='item-title'>{item.fileName}</div>
                                        <div className='item-subtitle'>
                                            {
                                                item?.finished && item?.finishedTs ?
                                                    `${'Exported'.translate(this.props.lang)}: ${this.props.getStringDateTs(item.finishedTs, `${this.props.dateFormat} HH:mm`)}`
                                                    :
                                                    `${'Export started'.translate(this.props.lang)}: ${this.props.getStringDateTs(item.tsCreated, `${this.props.dateFormat} HH:mm`)}`
                                            }
                                            {
                                                item?.user?.username ?
                                                    <>
                                                        <br />
                                                        {`${'Exported by'.translate(this.props.lang)}: ${item?.user?.username}`}
                                                    </>
                                                    :
                                                    null
                                            }

                                        </div>
                                    </div>
                                    <div className='export-data-actions'>
                                        {
                                            !item?.finished ?
                                                `${'In progress'.translate(this.props.lang)}...`
                                                :
                                                <>
                                                    <button className='export-record-delete' onClick={() => this.deleteExportRecord(item._id)}> <Isvg src={garabage} />  <div className="export-record-delete-tooltip">{'Delete'.translate(this.props.lang)}</div> </button>
                                                    {
                                                        url ?
                                                            <a href={url} target={'_blank'}>{'Download'.translate(this.props.lang)}</a>
                                                            :
                                                            null
                                                    }

                                                </>
                                        }
                                    </div>
                                </div>
                            )
                        })
                    }
                    {/* {
                        this.state.files && this.state.files.length ? this.state.files.map(item => {
                            return (
                                <div className="statistics-box-container" style={{ borderBottom: '1px solid #ddd', marginBottom: 15, paddingBottom: 5 }}>
                                    <div>
                                        <h6>{this.props.lang == 'en' ? item.name : item.nameSv}</h6>
                                        <p>{'From:'.translate(this.props.lang) + " " + moment(new Date(item.startDate)).format(this.props.dateFormat) + ' ' + 'to'.translate(this.props.lang) + ' ' + moment(new Date(item.endDate)).format(this.props.dateFormat)}</p>
                                    </div>
                                    <div>

                                        <button className='group-statistics-delete' style={{ backgroundColor: 'transparent', border: 'none' }} onClick={() => this.deleteFile(item._id)}> <Isvg src={garabage} />  <div className="group-statistics-delete-tooltip">{'Delete'.translate(this.props.lang)}</div> </button>
                                        <a href={API_ENDPOINT + `${this.props.lang == 'en' ? item.link : item.linkSv}`} target={'_blank'}>{'Download'.translate(this.props.lang)}</a>

                                    </div>

                                </div>
                            )
                        })
                            :
                            <div className="statistics-box-report">
                                <p>{"No reports created for this period".translate(this.props.lang)}</p>
                                <button className="btn add-button" onClick={() => this.setState({ createReportModal: true })}> {"Create new report".translate(this.props.lang)}</button>
                            </div>
                    } */}
                </div>
            </div>
        );
    }
}


export default PaymentExports;
